import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: window.appConfig.apiHost,  // api的base_url
  timeout: 30000                  // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (store.getters.authentication && store.getters.authentication.token) {
    // 让每个请求都添加token
    config.headers['Authorization'] = 'Bearer ' + store.getters.authentication.token
  }
  config.headers['Content-Type'] = 'application/json'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    // 对正常请求结果做一些操作或过滤
    if (response && response.data) {
      switch (response.data.code) {
        case 0:
          // 服务器返回正常结果
          return response.data.data
        case 401: // 未登录
        case 8010: // 多终端登录
          store.dispatch('invalidAuthentication')
          break
        case 403:
          // 未购买课程
          Message.error('您尚未购买课程')
          router.push('/help/buytip')
          return ''
      }
      // 其他情况，处理对应操作后进入catch
      return Promise.reject(response.data)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    console.log('apiErrpr: ' + error) // for debug
    // 请求发生错误时操作
    if (error.response) {
      switch (error.response.status) {
        case 404:
          // 不希望被catch捕获就返回空
          // return ''
          break
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/myAxios.js